import { useTranslation } from 'react-i18next';
import type { HeatmapCell, Skill, StaffMember } from '../../../types/weekOverview';
import { HEATMAP_TOOLTIP_ID, WEEKDAY_FULL_TRANSLATION_KEYS } from '../../../constants/weekOverviewConstants';
import styles from './WeekHeatmap.module.css';

interface HeatmapTooltipProps {
  cell: HeatmapCell;
  position: { x: number; y: number };
  skill: Skill | undefined;
  staff: StaffMember | undefined;
}

export const HeatmapTooltip = ({ cell, position, skill, staff }: HeatmapTooltipProps) => {
  const { t } = useTranslation();

  const title = staff ? staff.name : skill?.name ?? '';

  return (
    <div
      id={HEATMAP_TOOLTIP_ID}
      className={styles.tooltip}
      style={{
        left: position.x,
        top: position.y - 12,
        transform: 'translate(-50%, -100%)'
      }}
      role="tooltip"
    >
      <span className={styles.tooltipTitle}>
        {title} · {t(WEEKDAY_FULL_TRANSLATION_KEYS[cell.day])}
      </span>
      {cell.isClosed ? (
        <span className={styles.tooltipRow}>{t('week-overview-heatmap-tooltip-closed')}</span>
      ) : (
        <>
          <span className={styles.tooltipRow}>
            {t('week-overview-heatmap-tooltip-booked', {
              booked: cell.bookedHours,
              available: cell.availableHours
            })}
          </span>
          {!staff && (
            <span className={styles.tooltipRow}>
              {t('week-overview-heatmap-tooltip-staff', {
                scheduled: cell.staffScheduled,
                onLeave: cell.staffOnLeave
              })}
            </span>
          )}
        </>
      )}
    </div>
  );
};
